// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu_menu__iemD1","logoContainer":"menu_logoContainer__1K7T2","logo":"menu_logo__1c09E"};